import { gql } from '@apollo/client';

export const fetchBAReporting = gql`
  query getBAReporting($timespan: Long!, $startDate: String!, $endDate: String!) {
    brandAffinityReporting(timespan: $timespan, startDate: $startDate, endDate: $endDate) {
      projectId
      history {
        computedForDate
        labelCounts {
          brandAffinityLabel
          count
          percent
        }
      }
      deltas {
        brandAffinityLabel
        delta
        percent
      }
      transitionMap {
        count
        endBrandAffinityLabel
        startBrandAffinityLabel
      }
      engagementMetrics {
        brandAffinityLabel
        metrics {
          messageMedium
          metrics {
            count
            metricLabel
          }
        }
      }
      campaignImpacts {
        brandAffinityLabel
        campaignCount {
          count
          direction
          messageMedium
        }
        topCampaignsUpwards {
          campaignId
          messageMedium
          score
        }
        topCampaignsDownwards {
          campaignId
          messageMedium
          score
        }
      }
      unscoredMetrics {
        totalSendSkips
        uniqueUsersUnsub
        timespan
        topUnsubMessageTypeIds {
          id
          score
        }
        topUnsubChannelIds {
          id
          score
        }
      }
    }
  }
`;
